module.exports = __webpack_public_path__ + "static/astronaut-5c941d764fbb8599677af73d39b8d013.svg";